import { useEffect, useRef } from "react"

import Style from "./style"
import nationCode from "./asset/nation_code.json"

import SelectWithModal from "widget/SelectWithModal"

import usePostUtilSms from "entity/util/usePostUtilSms"
import usePostUtilSmsConfirm from "entity/util/usePostUtilSmsConfirm"

import useConfrimCookie from "shared/model/useConfrimCookie"

const ContactInput = ({ countryCode, countryCodeRef, contact, contactRef }) => {
    const codeRef = useRef()

    const [isSent, sentEvent] = usePostUtilSms(countryCodeRef, contactRef)
    const [confirmEvent] = usePostUtilSmsConfirm(countryCodeRef, contactRef, codeRef)
    const [confirmCookie, , deleteConfirmCookie] = useConfrimCookie()

    // 페이지 벗어날 때 임시 토큰 삭제
    useEffect(() => {
        return () => {
            deleteConfirmCookie()
        }
    }, [])

    // 수정 상태일 때 기본값 index 계산
    let defaultIndex = null
    for (let index = 0; index < nationCode.list.length; index++) {
        if (parseInt(nationCode.list[index].code) === countryCode) {
            defaultIndex = index
            break
        }
    }

    return (
        <>
            <Style.ContactInputDiv>
                <h2>연락처<span>*</span></h2>
                <Style.ContactInputForm $deactive={confirmCookie}>
                    <SelectWithModal title="국가번호 선택" optionList={nationCode.list} defaultOption="국가" defaultIndex={defaultIndex} inputRef={countryCodeRef} />
                    <input placeholder="연락처" defaultValue={contact} ref={contactRef} />
                    <button onClick={!confirmCookie ? sentEvent : null}>인증번호 받기</button>
                </Style.ContactInputForm>
                <Style.hint>"-" 없이 숫자만 입력해 주세요.</Style.hint>
            </Style.ContactInputDiv>


            {isSent &&
                <Style.ContactInputDiv>
                    <h2>인증번호<span>*</span></h2>
                    <Style.ContactInputForm $deactive={confirmCookie}>
                        <input placeholder="6자 숫자" ref={codeRef} />
                        <button onClick={!confirmCookie ? confirmEvent : null}>인증하기</button>
                    </Style.ContactInputForm>
                    {confirmCookie && <Style.option>인증되었습니다.</Style.option>}
                </Style.ContactInputDiv>
            }
        </>
    )
}

export default ContactInput